// short_text / email / number, and the base for anything that is a plain
// input. Saves on blur — never while typing.

import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import {
  FieldError,
  FieldHelper,
  FieldLabel,
  inputClass,
  textRules,
} from "./chrome";
import { V2FieldProps } from "./types";

const INPUT_TYPE_BY_FIELD_TYPE: Record<string, string> = {
  email: "email",
  number: "number",
};

export default function TextField({ field, onCommit }: V2FieldProps) {
  const { control } = useFormContext();
  const inputType = INPUT_TYPE_BY_FIELD_TYPE[field.type] ?? "text";
  const rules = textRules(field);
  if (field.type === "email") {
    rules.pattern = rules.pattern ?? {
      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "That doesn't look like an email address",
    };
  }

  return (
    <Controller
      control={control}
      name={field.ref}
      rules={rules}
      render={({ field: rhf, fieldState: { error } }) => (
        <div>
          <FieldLabel
            text={field.title}
            htmlFor={field.ref}
            optional={!field.required}
          />
          <input
            id={field.ref}
            name={rhf.name}
            ref={rhf.ref}
            type={inputType}
            value={rhf.value ?? ""}
            placeholder={field.placeholder}
            maxLength={field.maxLength}
            className={inputClass(Boolean(error))}
            onChange={rhf.onChange}
            onBlur={() => {
              rhf.onBlur();
              onCommit();
            }}
          />
          <FieldHelper text={field.description} />
          <FieldError message={error?.message} />
        </div>
      )}
    />
  );
}
